import { render, staticRenderFns } from "./myActiveReport_teacher.vue?vue&type=template&id=1ec9288f&scoped=true"
import script from "./myActiveReport_teacher.vue?vue&type=script&lang=js"
export * from "./myActiveReport_teacher.vue?vue&type=script&lang=js"
import style0 from "./myActiveReport_teacher.vue?vue&type=style&index=0&id=1ec9288f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9288f",
  null
  
)

export default component.exports